'use client';
import { fnv1aBM } from '@s7/utils';

/* Хэш темы используется в механизме кэширования в createStyles */ var attachThemeHash = function(theme) {
    theme.__hash = fnv1aBM(JSON.stringify(theme));
    return theme;
};

export { attachThemeHash };
